import { render, staticRenderFns } from "./ChoosePoster.vue?vue&type=template&id=8042680c&scoped=true&"
import script from "./ChoosePoster.vue?vue&type=script&lang=js&"
export * from "./ChoosePoster.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePoster.vue?vue&type=style&index=0&id=8042680c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8042680c",
  null
  
)

export default component.exports